import React from "react";
import { useClasses } from "../";
const styles = (theme) => ({
    wrapper: { padding: "16px 0px" },
    label: {
        fontSize: "0.8rem",
        textTransform: "uppercase",
        color: theme.palette.get("primary"),
        fontWeight: 600,
        letterSpacing: "1px",
    },
    body: {
        fontSize: "1rem",
        margin: "8px 0px 0px",
    },
});
export default function SidebarSection(props) {
    const classes = useClasses(styles);
    return (React.createElement("div", { className: classes.wrapper },
        React.createElement("div", { className: classes.label }, props.label),
        React.createElement("div", { className: classes.body }, props.children)));
}
